import axios from "axios";
import { v4 as uuid } from "uuid";
import { service } from "./utils/utils";
import * as env from "../environments/config";
import { getLocalStorageUserSession } from "./secureStorage";
import { http } from "../lib/http";

const cfg = process.env.REACT_APP_ENV ? ((env as any)[process.env.REACT_APP_ENV] ?? {}) : {};
const { API_UPLOAD, S3_BUCKET } = cfg;

export const getPresignedUrl = async (keys: { key: string }[]) => {
  try {
    const request: any = {
      url: `${API_UPLOAD}/url-prefirmadas/urls`,
      method: "post",
      body: {
        bucket: S3_BUCKET,
        keys,
      },
      requestConfig: {
        encryptedBody: ["bucket", "[keys].key"],
      },
      responseConfig: {
        encryptedResponse: ["[urls].url"],
      },
    };

    const response: any = await service(request);
    return response.data.data;
  } catch (error) {
    console.log("Error service getPresignedUrl: ", error);
    return [];
  }
};

export const getUploadingProgress = (uploadSize: number, totalSize: number) => {
  const uploadProgress = (uploadSize / totalSize) * 100;
  return Number(uploadProgress.toFixed(0));
};

export const formatDateForS3 = (date = new Date()) => {
  return date.toLocaleDateString("es-MX").replace(/\//g, "-");
};

export const generateS3KeyAuto = ({
  mimetype,
  companyId,
  date,
  idApp,
  originalName,
}: {
  mimetype: string;
  companyId: string;
  date: string;
  idApp: string;
  originalName: string; // ej: "Hola mundo!.jpg"
}) => {
  const extension = mimetype.split("/")[1] ?? "bin";
  const safeName = originalName
    .replace(/\.[^/.]+$/, "") // quita extensión del original
    .replace(/[^a-zA-Z0-9-_]/g, "_"); // limpia caracteres raros

  // const fileName = `${uuid()}-${safeName}`;

  return `Zeus/${companyId}/Asistencias/photos/${date}/${idApp}/${safeName}.${extension}`;
};

interface UploadMediaProps {
  file: File;
  onProgress?: (progress: any) => void;
}

type PresignResponse = {
  bucket: string;
  urls: { url: string }[];
};

// export const uploadMedia = async ({ file, onProgress }: UploadMediaProps) => {
//   const date = formatDateForS3(); // ej: 05-11-2025 (asegura formato EXACTO que usa el back)

//   const { data } = (await getLocalStorageUserSession()) as { data?: any };

//   // Valida que NO vengan undefined
//   const companyId = String(data?.company?.id ?? "");
//   const idApp = String(data?.tokens?.username ?? "");

//   if (!companyId || !idApp) {
//     throw new Error("Faltan companyId o idApp para construir la key.");
//   }

//   const key = generateS3KeyAuto({
//     mimetype: file.type,
//     companyId,
//     date,
//     idApp,
//     originalName: file.name,
//   })
//     .replace(/ /g, "_")
//     .trim();

//   try {
//     const presign: PresignResponse = await getPresignedUrl([{ key }]);
//     const signedUrl = presign?.urls?.[0]?.url;

//     if (!signedUrl) throw new Error("Presigned URL vacía en `urls[0].url`.");

//     const res = await http.put(signedUrl, file, {
//       headers: { "Content-Type": file.type || "application/octet-stream" },
//       transformRequest: [
//         (data, headers: any) => {
//           if (headers) {
//             delete headers.Authorization;
//             delete headers.common?.Authorization;
//           }
//           return data;
//         },
//       ],
//       onUploadProgress: (evt) => {
//         const total = evt.total ?? file.size ?? 0;
//         const loaded = evt.loaded ?? 0;
//         const percent = total > 0 ? Math.round((loaded * 100) / total) : 0;
//         onProgress?.({ loaded, total, percent });
//       },
//     });

//     if (res.status >= 200 && res.status < 300) {
//       return {
//         key,
//         url: signedUrl.split("?")[0],
//         etag: res.headers?.etag,
//       };
//     }
//     return null;
//   } catch (error: any) {
//     // Loguea el XML exacto de S3 para saber el motivo real
//     console.error("Upload error status:", error?.response?.status);
//     console.error("Upload error data:", error?.response?.data); // <Error><Code>...</Code>...
//     return null;
//   }
// };
